import React, { useRef, useState } from "react";
import { createRoot } from "react-dom/client";
import { FormBuilder } from "./form-builder";
const renderFormBuilder = ({
  hostElement,
  stylesUrl,
  formId,
  teamId,
  apiUrl,
  locale,
  formValues,
  tintAnonymousUid,
  onAfterSubmit,
  onAfterLoad,
  onBeforeSubmit,
  noTrack,
  accessToken,
  metadata
}) => {
  if (!hostElement) return;
  const isDialog = hostElement.parentNode.tagName === "DIALOG";
  let formBuilderInstance = null;
  const createShadowRoot = () => {
    const div = document.createElement("div");
    hostElement.appendChild(div);
    const wrapperDiv = hostElement.querySelector("div");
    return wrapperDiv.attachShadow({ mode: "open" });
  };
  const renderForm = (shadowRoot) => {
    const FormWrapper = () => {
      const [currentLocale, setCurrentLocale] = useState(locale);
      const formBuilderRef = useRef(null);
      formBuilderInstance = {
        changeLanguage: (newLocale) => {
          setCurrentLocale(newLocale);
        }
      };
      return /* @__PURE__ */ React.createElement(
        FormBuilder,
        {
          ref: formBuilderRef,
          config: {
            hostElement,
            formId,
            teamId,
            apiUrl,
            locale: currentLocale,
            formValues,
            tintAnonymousUid,
            noTrack,
            accessToken,
            metadata
          },
          onAfterLoad,
          onAfterSubmit,
          onBeforeSubmit
        }
      );
    };
    const root = createRoot(shadowRoot);
    root.render(
      /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("link", { rel: "stylesheet", href: stylesUrl }), /* @__PURE__ */ React.createElement(FormWrapper, null))
    );
  };
  if (isDialog) {
    if (hostElement.parentNode.open) {
      const shadowRoot = createShadowRoot();
      renderForm(shadowRoot);
    }
    const observer = new MutationObserver((mutationList) => {
      for (const mutation of mutationList) {
        if (mutation.type === "attributes" && mutation.attributeName === "open" && mutation.target.open) {
          const shadowRoot = createShadowRoot();
          renderForm(shadowRoot);
        } else {
          const wrapperDiv = hostElement.querySelector("div");
          if (wrapperDiv) {
            wrapperDiv.remove();
          }
        }
      }
    });
    observer.observe(hostElement.parentNode, { attributeFilter: ["open"] });
  } else {
    const shadowRoot = createShadowRoot();
    renderForm(shadowRoot);
  }
  if (!window.Tint) {
    window.Tint = {};
  }
  window.Tint.changeLanguage = (newLocale) => {
    if (formBuilderInstance) {
      formBuilderInstance.changeLanguage(newLocale);
    } else {
      console.warn("FormBuilder instance is not initialized yet.");
    }
  };
};
if (window.Tint) {
  window.Tint.tintFormBuilderRender = renderFormBuilder;
} else {
  window.Tint = {
    tintFormBuilderRender: renderFormBuilder
  };
}
